import * as React from 'react'
//import Iframe from 'react-iframe'
import { Embed, models, Report } from 'powerbi-client'
import { PowerBIEmbed } from 'powerbi-client-react'

import { IAuthService } from '../../services/security/AuthService'
import { IUtilityService } from '../../services/UtilityService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { EmbedConfig, EmbedToken } from '../../models/EmbedConfig'
import { PrinterOutlined } from '@ant-design/icons'
import { Button, PageHeader } from 'antd'

interface DashboardProps {
    anno: number
    cliente?: string
}

export class Dashboard extends React.Component<DashboardProps, any> {

    authService: IAuthService
    utilityService: IUtilityService
    report: Report
    token: string

    constructor(props) {
        super(props)

        var model = new EmbedConfig()
        model.EmbedToken = new EmbedToken()
        this.state = model;

        this.utilityService = container.get(SERVICE_IDENTIFIER.UTILITY_SERVICE)
        this.authService = container.get(SERVICE_IDENTIFIER.AUTH_SERVICE)
    }

    async componentDidMount() {
        this.token = this.authService.getToken()
        await this.loadReport()

    }

    private async loadReport() {
        var model = await this.utilityService.GetReportByName('Report', this.props.cliente)
        //var model = await this.utilityService.GetReport('0b1611b6-6a1a-4134-aa93-82d5df77b10f', 'b7c2a451-8117-45ca-9be9-692ac36b8d19');
        //var model = await this.utilityService.GetDashboard('87138ce4-ba20-41f7-8ca8-544c94a32608', 'b7c2a451-8117-45ca-9be9-692ac36b8d19',' 94f688f7-4557-4d77-a28b-5bf29fe09392');
        this.setState(model)
    }

    async componentDidUpdate(prevProps: DashboardProps) {
        //if (this.token != this.authService.getToken()) {
        //    console.log('Dash update');
        //    this.token = this.authService.getToken();
        //    await this.loadReport();
        //}

        if (prevProps.anno !== this.props.anno)
            this.report.reload()
    }

    setReport(report: Report) {
        this.report = report
    }

    render() {
        return (
            <>
                <PageHeader title="Dashboard" style={{ paddingBottom: '0px' }} extra={[
                    <Button type="primary" shape="circle" icon={<PrinterOutlined />} onClick={async (a) => await this.report.print()} />
                ]}/>
                {/*<Iframe width="100%" height="1060" 
                url="https://app.powerbi.com/view?r=eyJrIjoiZTZlN2IwYTMtYWM1Mi00NjcxLTkxM2EtYTFiYTgzNDBmY2Q3IiwidCI6IjExZjhiZjg3LWYzNWMtNGZjOC1hZWM2LTk5NTVhZDc5MzhkYiIsImMiOjh9&pageName=ReportSectiona7095b867a98306a2f5d"
                        frameBorder={0} allowFullScreen={true} />*/}
                
                <PowerBIEmbed 
                    cssClassName={"report-style-class"}
                    embedConfig={{
                        type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                        embedUrl: this.state.EmbedUrl,
                        accessToken: this.state.EmbedToken.token,    // Keep as empty string, null or undefined
                        tokenType: models.TokenType.Embed,
                        settings: {
                            filterPaneEnabled: false
                        }
                        //pageName: 'ReportSection2187785be505103de4cd',
                        //visualName: '8b63b4e1e5beb83b5d63'
                    }}
                    getEmbeddedComponent={(embedObject: Embed) => {
                        console.log(`Embedded object of type "${embedObject.embedtype}" received`)
                        this.setReport(embedObject as Report)
                    }}
                    eventHandlers={new Map([
                        ['loaded',async (e) => {
                            console.log('Report has loaded')

                            var filter = {
                                $schema: "http://powerbi.com/product/schema#basic",
                                target: {
                                    table: "Data",
                                    column: "YearNr"
                                },
                                operator: "In",
                                values: [this.props.anno],
                                filterType: 1
                            }
                            //this.report.setFilters([filter])


                            const pages = await this.report.getPages();
                            debugger;
                            // Retrieve the active page.
                            pages.filter(function (page) {
                                return page.name !="ReportSection89f391d3c588720c50b9"
                            }).map(async p => {
                                await p.updateFilters(models.FiltersOperations.RemoveAll);
                                await p.updateFilters(models.FiltersOperations.Add, [filter]);
                            });

                            
                            console.log("Page filter was addes except ReportSection89f391d3c588720c50b9.");

                        }],
                        ['rendered', (e) => {
                            console.log('Report has rendered')

                            //this.report.getPages().then(pages => {
                            //    debugger
                            //    pages[1].getVisuals().then(visuals => console.log(visuals))


                        }]])}
                />

                {/*<PowerBIEmbed
                    cssClassName={"report-style-class"}
                    embedConfig={{
                        type: 'dashboard',   // Supported types: report, dashboard, tile, visual and qna
                        id: '87138ce4-ba20-41f7-8ca8-544c94a32608',
                        embedUrl: this.state.EmbedUrl,
                        accessToken: this.state.EmbedToken.token,    // Keep as empty string, null or undefined
                        tokenType: models.TokenType.Embed
                    }}
                />*/}
            </>
        )
    }
}